import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { ScreenFrame, ListCard, EmptyState, ViewToggle } from '../PrototypeShared';
import { Warning } from '@mui/icons-material';

const MOCK_RECALLS = [
  { id: 'R1', product: 'Demo lot impact', status: 'Open', date: '2024-03-01' },
  { id: 'R2', product: 'Mix batch Y', status: 'Closed', date: '2024-02-15' },
];

export default function RecallsScreen() {
  const [view, setView] = useState('list');

  return (
    <ScreenFrame
      title="Recalls"
      actions={
        <>
          <ViewToggle value={view} onChange={setView} options={[{ value: 'list', label: 'With data' }, { value: 'empty', label: 'Empty' }]} />
          <Button component={Link} to="/prototype/recalls/new" startIcon={<Add />} variant="contained" size="small">New recall</Button>
        </>
      }
    >
      {view === 'empty' && (
        <EmptyState icon={Warning} title="No recalls" description="No recall campaigns." actionLabel="New recall" onAction={() => window.location.assign('/prototype/recalls/new')} />
      )}
      {view === 'list' && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {MOCK_RECALLS.map((r) => (
            <ListCard key={r.id} title={`Recall ${r.id}`} subtitle={`${r.product} · ${r.date}`} status={r.status} to={`/prototype/recalls/${r.id}`} />
          ))}
        </Box>
      )}
    </ScreenFrame>
  );
}
